module.exports = __webpack_public_path__ + "img/DSC_2736-xl.7607cdcc.png";